import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { DestroyListenerMgr } from "abweb/service/destroyListener/DestroyListenerMgr";
export class RegisterDestroyListenerImpl {
  constructor() {
    _defineProperty(this, "destroyListenerMgr", new DestroyListenerMgr());
  }
  /**
   * @inheritDoc
   */
  registerDestroyListener(listener) {
    return this.destroyListenerMgr.registerDestroyListener(listener);
  }

  /**
   * @inheritDoc
   */
  registerAsyncDestroyListener(listener) {
    return this.destroyListenerMgr.registerAsyncDestroyListener(listener);
  }

  /**
   * @inheritDoc
   */
  removeAsyncDestroyListener(listener) {
    this.destroyListenerMgr.removeAsyncDestroyListener(listener);
  }
}
//# sourceMappingURL=RegisterDestroyListenerImpl.js.map
